/**
 * IT Email service - API calls for work email workflow
 * Uses axios directly without auth interceptor (public endpoints with token-based auth)
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

export interface WorkEmailFormData {
  employee_id: number;
  first_name: string;
  middle_name?: string;
  last_name: string;
  personal_email: string | null;
  work_email: string | null;
  employee_type?: string | null;  // Added for contractor email validation
  comments?: string | null;  // HR notes/access requirements
  hire_date?: string | null;
  // What HR requested (required items)
  work_email_required: boolean;
  outlook_required: boolean;
  teams_required: boolean;
  laptop_required: boolean;
  wifi_required: boolean;
  // Onboarding checklist current state
  work_email_created: boolean;
  outlook_configured: boolean;
  teams_configured: boolean;
  laptop_assigned: boolean;
  wifi_configured: boolean;
  other_checklist?: string | null;
  custom_checklist_items?: string | null;  // JSON string: [{"name": "VPN Access", "completed": false}, ...]
}

export interface WorkEmailSubmitResponse {
  message: string;
  employee_id: number;
  work_email: string;
}

export const itEmailService = {
  /**
   * Get form data using token (public endpoint)
   */
  async getFormData(token: string): Promise<WorkEmailFormData> {
    const response = await axios.get(`${API_BASE}/it-email/form/${token}`);
    return response.data;
  },

  /**
   * Submit work email, temporary password, and checklist using token (public endpoint)
   */
  async submitWorkEmail(
    token: string,
    workEmail: string,
    temporaryPassword: string,
    itEmail: string,
    checklist: {
      work_email_created: boolean;
      outlook_configured: boolean;
      teams_configured: boolean;
      laptop_assigned: boolean;
      wifi_configured: boolean;
      other_checklist?: string;
      custom_checklist_items?: string;
    }
  ): Promise<WorkEmailSubmitResponse> {
    const response = await axios.post(`${API_BASE}/it-email/form/${token}/submit`, {
      work_email: workEmail,
      temporary_password: temporaryPassword,
      it_email: itEmail,
      ...checklist,
    });
    return response.data;
  },
};
